import React from 'react';
import { Link as ChakraLink, Text } from '@chakra-ui/react';
import { Link as ReactRouterLink } from 'react-router-dom';

export const Link = ({ to, href, title, onClick }) => {
  if (to) {
    return (
      <ChakraLink
        as={ReactRouterLink}
        to={to}
        color="blue.500"
        textDecoration="underline"
        onClick={() => {
          if (onClick) {
            onClick();
          }
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
      >
        {title}
      </ChakraLink>
    );
  }
  if (href) {
    return (
      <ChakraLink
        href={href}
        color="blue.500"
        textDecoration="underline"
        isExternal
      >
        {title}
      </ChakraLink>
    );
  }
  return <Text style={{ textDecoration: 'underline' }}>{title}</Text>;
};
